// React
import React from "react";
// Bootstrap
import { Well } from "react-bootstrap";
//-------------------------------------------------------------------------------------------------------------------------------
// Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./FormServerError.less";
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
export class FormServerError extends React.Component {
    render() {
        let { form } = this.props;
        if (form.errors["serverError"]) {
            return (React.createElement("div", { className: "form-group" },
                React.createElement(Well, { bsSize: "small", className: styles.serverErrorMessage },
                    "Error: ",
                    form.errors["serverError"])));
        }
        else {
            return React.createElement("div", null);
        }
    }
}
